import ky from 'ky';
import { ENV } from 'src/utils/env';
import { getHeadersWithBearerToken } from 'src/utils/get-auth-with-bearer';
import { z } from 'zod';

export const REMOVE_DETECTION_ZONES_SCHEMA = z.object({
  display_id: z.string(),
});

export type RemoveDetectionZonesSchema = z.infer<typeof REMOVE_DETECTION_ZONES_SCHEMA>;

export const REMOVE_DETECTION_ZONES_RESPONSE_SCHEMA = z.object({
  message: z.string(),
});

export type RemoveDetectionZonesResponseSchema = z.infer<typeof REMOVE_DETECTION_ZONES_RESPONSE_SCHEMA>;

export const removeDetectionZonesPromise = async (params: RemoveDetectionZonesSchema) => {
  try {
    const headers = getHeadersWithBearerToken();
    headers.append('Content-Type', 'application/json');

    const parsedParams = REMOVE_DETECTION_ZONES_SCHEMA.safeParse(params);

    if (!parsedParams.success) {
      throw new Error('invalid params');
    }

    const response = await ky.delete(`${ENV.API_URL}/api/edit_detection_zone/${params.display_id}`, {
      headers,
    });

    const validatedResponse = REMOVE_DETECTION_ZONES_RESPONSE_SCHEMA.safeParse(await response.json());

    if (!validatedResponse.success) {
      console.error(
        '🚀 ~ file: removeDetectionZonePromise.ts:29 ~ createStorePromise ~ validatedResponse',
        validatedResponse
      );
      return false;
    }

    return validatedResponse.data.message?.toLowerCase()?.includes('successfully');
  } catch (error) {
    console.error('Error removing detection zones:', error);
    return false;
  }
};
